import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timePicker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flat_pickr = _resolveComponent("flat-pickr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_flat_pickr, {
      id: "timeInput",
      modelValue: _ctx.localSelectedTime,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSelectedTime) = $event)),
      config: _ctx.flatpickrConfig,
      disabled: _ctx.disabled,
      onChange: _ctx.updateTime
    }, null, 8, ["modelValue", "config", "disabled", "onChange"])
  ]))
}